import { BoxProps, default as MuiBox } from '@mui/material/Box'
import { default as React } from 'react'

export type { BoxProps }

const Box = <D extends React.ElementType, P = Record<string, never>>(props: BoxProps<D, P>) => {
  return <MuiBox {...props} />
}

export default Box
